import React from 'react'
import InspectionsGrid from './Grid';
import { useAppContext } from 'hooks/useAppContext';
import FieldTests from 'components/FieldTests';
import Samples from 'components/Samples';
import Equipment from 'components/Equipment';
import DelayDataTable from 'components/Delays';
import AccidentDataTable from 'components/Accidents';
import MaterialDeliveryDataTable from 'components/MaterialDeliveries';
import InspectionCommentsDataTable from 'components/InspectionComments';
import Issues from 'components/Issues';
import Checklist from 'components/Checklist';
import Visitor from 'components/Visitor';
import CommunicationEvent from 'components/CommunicationEvent';
import WorkforceLabor from 'components/WorkforceLabor';
import WeatherImpact from 'components/WeatherImpact';
import Observation from 'components/Observation';
import WorkItemTracking from 'components/WorkItemTracking';

export default function Inspections() {
  const { currentModuleFilter, subModule1 } = useAppContext(); //Getting the App Context

  return (
    <>
    {
      /**
       * Inspections supports sub-routes. If the application has a subModule1 through /inspections,
       * i.e. http://localhost:3000/projects/aa8e7f82-ffb0-4f7d-9dfe-2516a63d0ffe/inspections/a.l-20H07M47S-8/samples
       * Then it will render the submodules compoenent with a "customFilter" prop to filter the table to the selected
       * inspection.
       */
      (() => {
        const subModuleLower = subModule1 ? subModule1.toLowerCase() : undefined;
        switch(subModuleLower) {
        case "fieldtests".toLowerCase():
          return <FieldTests customFilter={{inspectionNumber: currentModuleFilter}} />;
        case "samples".toLowerCase():
          return <Samples customFilter={{inspectionNumber: currentModuleFilter}} />;
        case "equipment".toLowerCase():
          return <Equipment customFilter={{inspectionNumber: currentModuleFilter}} />;
        case "delays".toLowerCase():
          return <DelayDataTable customFilter={{InspectionNumber_Inspection: currentModuleFilter}} />;
        case "accidents".toLowerCase():
          return <AccidentDataTable customFilter={{InspectionNumber_Inspection: currentModuleFilter}} />;
        case "comments".toLowerCase():
          return <InspectionCommentsDataTable customFilter={{InspectionNumber_Inspection: currentModuleFilter}} />;
        case "deliveries".toLowerCase():
          return <MaterialDeliveryDataTable customFilter={{InspectionNumber_Inspection: currentModuleFilter}} />;
        case "issues".toLowerCase():
          return <Issues customFilter={{InspectionNumber_Inspection: currentModuleFilter}} />;
        case "checklist":
          return <Checklist />;
        case "visitor":
          return <Visitor />;
        case "communicationevent":
          return <CommunicationEvent />;
        case "workforcelabor":
          return <WorkforceLabor />;
        case "weatherimpact":
          return <WeatherImpact />;
        case "observation":
          return <Observation />;
        case "workitemtracking":
          return <WorkItemTracking />;
          default:
          return <InspectionsGrid inspectionNumber={currentModuleFilter} />
        }
      })()
    }
    </>
  )
}